<template>
  <div class="home">
    <Navbar />
    <vue-headful title="CHECK PHONE" />
    <fish-segment>
      <fish-loader :active="isLoading"></fish-loader>
      <a-row>
        <a-col :xs="0" :sm="6" :md="6"  :lg="6"></a-col>
        <a-col :xs="24" :sm="12" :md="12"  :lg="12">
          <fish-card fluid style="height:160px">
            <div slot="header">CHECK PHONE</div>

            <a-form style="width:100%" :form="form" @submit="handleSubmit">
              <a-form-item :validate-status="CodeError() ? 'error' : ''" :help="CodeError() || ''">
                <a-input
                  style="width:100%"
                  v-decorator="[
                        'Phone',
                        { rules: [{ required: true, message: 'Vui lòng điền số điện thoại cần kiểm tra!' },{len:10,message:'Vui lòng nhập SĐT (10 ký tự)'}] },
                        ]"
                  placeholder="Nhập số điện thoại cần kiểm tra"
                >
                  <a-icon slot="prefix" type="key" style="color:rgba(0,0,0,.25)" />
                </a-input>
              </a-form-item>
              <a-form-item>
                <a-button
                  type="primary"
                  html-type="submit"
                  :disabled="hasErrors(form.getFieldsError())"
                >
                  <i class="fa fa-search" aria-hidden="true"></i>
                  <span>CHECK</span>
                </a-button>
              </a-form-item>
            </a-form>

            <!-- <fish-form inline width="100%">
            <fish-field span="18">
              <fish-input hint="Nhập mã CODE hoặc HASHCODE" :iconLeft="true" icon="fa fa-key"></fish-input>
            </fish-field>
            <fish-button type="primary">
              <i class="fa fa-search" style="margin-right: .5em;"></i>CHECK
            </fish-button>
            </fish-form>-->
          </fish-card>
        </a-col>
        <a-col :xs="0" :sm="6" :md="6"  :lg="6"></a-col>
      </a-row>

      <br />
      <a-row>
        <a-col :xs="0" :sm="6" :md="6"  :lg="6"></a-col>
        <a-col :xs="24" :sm="12" :md="12"  :lg="12">
          <fish-card fluid color="orange" v-if="oCustomer">
            <div slot="header">THÔNG TIN KHÁCH HÀNG</div>
            <a-row>
              <a-col span="24"  class="pnlInfo">
                <a-row>
                  <a-col span="8" style="padding-right:5px">
                    <div class="demo-col">
                      <fish-card>
                        <div slot="header">
                          <strong>TỔNG SMS</strong>
                        </div>
                        <fish-row>
                          <!-- <fish-col span="6">
                            <img
                              width="100%"
                              src="https://image.flaticon.com/icons/svg/2235/2235311.svg"
                            />
                          </fish-col> -->
                          <fish-col span="24">
                            <br />
                            <span>
                              <b style="color:black;font-size:3vw">{{oCustomer.SMS_All_Counter}}</b>
                            </span>
                            <p>
                              <span>
                                <br />
                              </span>
                            </p>
                          </fish-col>
                        </fish-row>
                      </fish-card>
                    </div>
                  </a-col>
                  <a-col span="8" style="padding-right:5px">
                    <div class="demo-col demo-col2">
                      <fish-card :color="oCustomer.IsBlock?'yellow':''">
                        <div slot="header">
                          <strong>TOPUP/NGÀY</strong>
                        </div>
                        <fish-row>
                          <!-- <fish-col span="6">
                            <img
                              v-if="oCustomer.IsBlock"
                              width="100%"
                              src="https://image.flaticon.com/icons/svg/1296/1296024.svg"
                            />
                            <img
                              v-else
                              width="100%"
                              src="https://image.flaticon.com/icons/svg/1722/1722017.svg"
                            />
                          </fish-col> -->
                          <fish-col span="24">
                            <div v-if="oCustomer.IsBlock">
                              <a-tag color="orange">TẠM KHÓA</a-tag>
                            </div>
                            <span v-else>
                              <br />
                            </span>
                            <span>
                              <b style="color:black;font-size:3vw">{{oCustomer.SMS_Day_Counter}}</b>
                            </span>

                            <div>
                              <span
                                style="color:red"
                                v-if="oCustomer.IsBlock"
                              >{{oCustomer.Block_Date | moment("DD/MM/YYYY HH:mm:ss")}}</span>
                              <span v-else>
                                <br />
                              </span>
                            </div>
                          </fish-col>
                        </fish-row>
                      </fish-card>
                    </div>
                  </a-col>
                  <a-col span="8">
                    <div class="demo-col">
                      <fish-card :color="oCustomer.IsBlackList?'red':''">
                        <div slot="header">
                          <strong>TỔNG TOPUP</strong>
                        </div>
                        <a-row>
                          <!-- <fish-col span="6">
                            <img
                              v-if="oCustomer.IsBlackList"
                              width="100%"
                              src="https://image.flaticon.com/icons/svg/2525/2525754.svg"
                            />
                            <img
                              v-else
                              width="100%"
                              src="https://image.flaticon.com/icons/svg/1722/1722017.svg"
                            />
                          </fish-col> -->
                          <a-col span="24">
                            <div v-if="oCustomer.IsBlackList">
                              <a-tag color="red">ĐÃ KHÓA</a-tag>
                            </div>
                            <span v-else>
                              <br />
                            </span>
                            <span>
                              <b style="color:black;font-size:3vw">{{oCustomer.SMS_Counter}}</b>
                            </span>
                            <div>
                              <span
                                style="color:red"
                                v-if="oCustomer.IsBlackList"
                              >{{oCustomer.BlackList_Date | moment("DD/MM/YYYY HH:mm:ss")}}</span>
                              <span v-else>
                                <br />
                              </span>
                            </div>
                          </a-col>
                        </a-row>
                      </fish-card>
                    </div>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </fish-card>
        </a-col>
        <a-col :xs="0" :sm="6" :md="6"  :lg="6"></a-col>
      </a-row>
      <br />
      <a-table
        rowKey="Index"
        size="small"
        :columns="columns"
        :data-source="TBLdata"
        :pagination="false"
        :scroll="{ x: 600 }"

      >
        <span slot="Request_Time" slot-scope="text">{{ text | moment("DD/MM/YYYY HH:mm:ss")}}</span>
        <span slot="Scratch_Status" slot-scope="text">
          <a-tag
            :key="text"
            :color="text.toLowerCase()=='success'?'green':
            text.toLowerCase()=='notyet'?'cyan':
            text.toLowerCase()=='enddate'?'yellow':
            text.toLowerCase()=='wrong'?'orange':
            text.toLowerCase()=='duplicate'?'blue':
            text.toLowerCase()=='block'?'pink':'red'"
          >
            {{ text.toLowerCase()=="success"?"Trúng thưởng":
            text.toLowerCase()=="notyet"?"Chưa bắt đầu":
            text.toLowerCase()=="enddate"?"Chương trình kết thúc":
            text.toLowerCase()=="wrong"?"Không chính xác":
            text.toLowerCase()=="duplicate"?"Đã tồn tại":
            text.toLowerCase()=="block"?"Quá 30Topup/ngày":"Không được tham gia"
            }}
          </a-tag>
        </span>
      </a-table>
      <br />

    </fish-segment>
  </div>
</template>

<script>
function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import { mapActions } from "vuex";
const moment = require("moment");
export default {
  name: "Home",
  components: {
    Navbar,
  },
  mounted() {
    this.$nextTick(() => {
      // To disabled submit button at the beginning.
      this.form.validateFields();
    });
  },
  data() {
    return {
      isLoading: false,
      hasErrors,
      oCustomer: null,
      form: this.$form.createForm(this, { name: "horizontal_login" }),
      TBLdata: [],
      columns: [
        { title: "#", dataIndex: "Index", key: "Index",width:"40px" },
        { title: "SĐT", dataIndex: "User_ID", key: "User_ID" },
        { title: "Nội dung", dataIndex: "Message", key: "Message" },
        {
          title: "Ngày nhắn",
          dataIndex: "Request_Time",
          key: "Request_Time",
          scopedSlots: { customRender: "Request_Time" },
        },
        {
          title: "Trạng thái",
          dataIndex: "Scratch_Status",
          key: "Scratch_Status",
          scopedSlots: { customRender: "Scratch_Status" },
        },
        { title: "Giải thưởng", dataIndex: "AwardType", key: "AwardType" },
        // {
        //   title: "Trạng thái",
        //   dataIndex: "IsAvaiable",
        //   key: "IsAvaiable",
        //   scopedSlots: { customRender: "IsAvaiable" },
        // },
      ],
    };
  },
  methods: {
    // Only show error after a field is touched.
    ...mapActions(["API_CheckPhone"]),
    CodeError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("Phone") && getFieldError("Phone");
    },
    // Only show error after a field is touched.
    async handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.isLoading = true;
            let checkData = await this.API_CheckPhone(values.Phone);
            // console.log(checkData.data.Message);
            if (checkData.data.State == 1) {
              this.oCustomer = checkData.data.Message.Customer;
              this.TBLdata = checkData.data.Message.Data.sort(function (a, b) {
                return moment(b.Request_Time) - moment(a.Request_Time);
              });

              this.TBLdata = this.TBLdata.filter(
                (st) => (st["Index"] = this.TBLdata.indexOf(st) + 1)
              );
            } else {
              this.$message.error(checkData.data.Message, 3000);
            }
            this.isLoading = false;
          } catch (err) {
            this.isLoading = false;
          }
        }
      });
    },
  },
};
</script>

<style>
.pnlInfo .header{
  padding: 0.7em 0.5em!important;
}
</style>